import { Navigate } from 'react-router-dom'

export const AddPolicy = () => <Navigate to='/hr/attendance/policies/edit' replace />

export {
  attendancePolicyResolverTypeOptions as resolverTypeOptions,
} from 'types/attendancePolicy.interface'
export type { IAttendancePolicyState } from 'types/attendancePolicy.interface'
